import { render, staticRenderFns } from "./cModalMedicine.vue?vue&type=template&id=82795fb4"
import script from "./cModalMedicine.vue?vue&type=script&lang=js"
export * from "./cModalMedicine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports